import React, { useEffect, useRef } from "react";
import "./DatePicker.scss";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { findScheduleByDate } from "./DatePickerUtils";

function DatePicker({ schedules, setDate, getScheduleDetails, clearDeatils, value }) {
  const calendarComponentRef = useRef(null);
  const handleDateSelect = (dateInfo) => {
    // console.log("dateInfo: "+ JSON.stringify(dateInfo));
    const event = findScheduleByDate(dateInfo.start, schedules);
    const flag = event?.isAvailable;

    if (!flag) {
      calendarComponentRef.current.getApi().unselect();
      clearDeatils();
      // NotificationManager.warning(
      //   "No Available Slot. Please try some other day.",
      //   ""
      // );
    } else {
      const start = dateInfo.start;
      // const localStart = getLocalDate(start);
      // console.log(`start date: ${start}, local start date: ${localStart}`);
      setDate(start);
      getScheduleDetails(start);
      if (window.innerWidth < 769) {
        const element = document.getElementById("slotPicker");
        // console.log("slotPicker: " + element);
        const headerOffset = 90;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  };

  const injectCellClassName = ({ date }) => {
    const schedule = findScheduleByDate(date, schedules);
    return schedule?.isAvailable ? "" : "disabled";
  };

  useEffect(() => {
    if (schedules && schedules[0]) {
      const fistSlot = schedules[0];
      calendarComponentRef.current
        .getApi()
        .select({ start: new Date(fistSlot.start) });
    }
  }, [schedules]);

  return (
    <>
      <div className="calendar__wrapper">
        <FullCalendar
          ref={calendarComponentRef}
          headerToolbar={{
            left: "prev",
            center: "title",
            right: "next",
          }}
          dayCellClassNames={injectCellClassName}
          height="auto"
          timeZone="local"
          unselectAuto={false}
          fixedWeekCount={false}
          initialView="dayGridMonth"
          selectable={true}
          select={handleDateSelect}
          longPressDelay={10}
          plugins={[dayGridPlugin, interactionPlugin]}
        />
      </div>
      <div className="Legend-grid">
        <div className="Legend-div">
          <div className="Blue">&nbsp;</div>
        </div>
        <div>Selected</div>
        <div className="Legend-div">
          <div className="Grey">&nbsp;</div>
        </div>
        <div> Not Available</div>
        <div className="Legend-div">
          <div className="Red">&nbsp;</div>
        </div>
        <div>Weekend</div>
      </div>
    </>
  );
}

export default DatePicker;
